import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Loader,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
  ICONS,
  Icon,
  EmptyContainer,
  EMPTY_ILLUSTRATIONS,
} from '@thinknet-gmbh/platform-common-ui';
import { VacancyPatternStatusesEnum } from '@thinknet-gmbh/platform-common';

import { useGetVacancyById } from 'src/hooks/vacancies-patterns/get-vacancy-by-id.hook';

import {
  HeaderSection,
  HeaderBackgroundImage,
  CompanyLogoWrapper,
  ContentWrapper,
  PageWrapper,
} from './applicant-request-page.styles';
import { ApplicantRequestForm } from './components';
import { DEFAULT_BACKGROUND_IMG } from './applicant-request-page.constants';

const ApplicantRequestPage = () => {
  const { t } = useTranslation('vacancies');
  const params = useParams();
  const { vacancy, loading, error } = useGetVacancyById(params.id?.slice(1));

  if (vacancy.status === VacancyPatternStatusesEnum.CLOSED || error) {
    return (
      <PageWrapper>
        <EmptyContainer
          illustration={EMPTY_ILLUSTRATIONS.error}
          emptyTitle={t('emptyContainer.title')}
          contentText={t('emptyContainer.subtitle')}
        />
      </PageWrapper>
    );
  }

  if (loading) {
    return (
      <PageWrapper>
        <Loader />
      </PageWrapper>
    );
  }

  return (
    <div>
      <HeaderSection>
        <HeaderBackgroundImage
          src={vacancy.headerImage ? vacancy.headerImage.location : DEFAULT_BACKGROUND_IMG}
          alt="Background"
        />
        <CompanyLogoWrapper>
          {vacancy.company.logoUrl ? (
            <img src={vacancy.company.logoUrl} alt="Logo" />
          ) : (
            <Icon icon={ICONS.defaultCompanyLogo} size={60} rightMargin={false} />
          )}
        </CompanyLogoWrapper>
      </HeaderSection>
      <ContentWrapper>
        <Typography
          weight="bold"
          fontColor={PLATFORM_THEME_COLORS.grayVariations.murky}
          size={TYPOGRAPHY_SIZE.x2Large}
        >
          {vacancy.company.name}
        </Typography>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.xBig}>
          {vacancy.job.title}
        </Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey} size={TYPOGRAPHY_SIZE.medium}>
          {t('vacancies:labels.applicantFormDescription')}
        </Typography>
        <ApplicantRequestForm vacancyId={vacancy._id} />
      </ContentWrapper>
    </div>
  );
};

export default ApplicantRequestPage;
